module.exports = __webpack_public_path__ + "img/专业团队.cb987945.jpg";